export const getTypes = store => store.types.data;

export const getPublicTypes = store => store.public_types.data;
